var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.728 32.728A18 18 0 117.272 7.273a18 18 0 0125.456 25.455zM20.025 25.77a2.34 2.34 0 00-2.018 1.129l-.006.009c-.399.723-.405 1.572.003 2.258.412.744 1.174 1.133 2.021 1.133.802 0 1.56-.393 1.971-1.133.408-.687.402-1.535.003-2.258l-.006-.01a2.318 2.318 0 00-1.968-1.128zm1.91-3.628V11.57c0-1.007-.896-1.871-1.91-1.871-1.07 0-1.91.87-1.91 1.871v10.572c0 1.056.846 1.871 1.91 1.871 1.008 0 1.91-.809 1.91-1.871z"
  })));
}
export default SvgExclamationCircle;